import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { AutocompleteListProjects } from "../../tasks/AutocompleteListProjects"

const statusList = [
    { id: 'por hacer', nombre: 'por hacer' },
    { id: 'en proceso', nombre: 'en proceso' },
    { id: 'completado', nombre: 'completado' },
    { id: 'stand-by', nombre: 'stand-by' },
    { id: 'todos', nombre: 'todos' }
]

const programList = ['programadas', 'no programadas']

export const FiltersMoreOptions = ({ filters, setFilters, handleFilters, pathName, usuariosTarea }) => {
    return (
        <div className="tasks-filter-options flex flex-wrap justify-start items-center">

            {pathName === 'tasks' ?
                <div className="w-80 mt-1">
                    <AutocompleteListProjects
                        handleFilters={handleFilters}
                    />
                </div> : ''
            }

            <div style={{ width: '200px' }} className="mt-1 ms-2">
                <FormControl fullWidth size="small">
                    <InputLabel id="tasks-filter-responsable">Responsable</InputLabel>
                    <Select
                        labelId="tasks-filter-responsable"
                        label="Responsable"
                        id="id_responsable"
                        name="id_responsable"
                        value={filters?.id_responsable || ''}
                        onChange={handleFilters}
                        className='p-list-capitalize'
                    >
                        <MenuItem value='' key=''>Ninguno</MenuItem>
                        {usuariosTarea?.map(item => (
                            <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                {item.nombre}{' '}{item.apellidos}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            <div style={{ width: '200px' }} className="mt-1 ms-2">
                <FormControl fullWidth size="small">
                    <InputLabel id="tasks-filter-estado">Estado</InputLabel>
                    <Select
                        labelId="tasks-filter-estado"
                        label="Estado"
                        id="estado"
                        name="estado"
                        value={filters?.estado || ''}
                        onChange={handleFilters}
                        className='p-list-capitalize'
                    >
                        <MenuItem value='' key=''>Ninguno</MenuItem>
                        {statusList?.map(its => (
                            <MenuItem value={its.id} key={its.id}
                                className='p-list-capitalize'>
                                {its.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            <div style={{ width: '200px' }} className="mt-1 ms-2">
                <FormControl fullWidth size="small">
                    <InputLabel id="tasks-filter-programacion">Programadas</InputLabel>
                    <Select
                        labelId="tasks-filter-programacion"
                        label="Programadas"
                        id="programacion"
                        name="programacion"
                        value={filters?.programacion || ''}
                        onChange={handleFilters}
                        className='p-list-capitalize'
                    >
                        <MenuItem value='' key=''>Ninguno</MenuItem>
                        {programList?.map(status => (
                            <MenuItem value={status} key={status}
                                className='p-list-capitalize'>
                                {status}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

        </div>
    )

}